import React, { useEffect, useRef, useState } from 'react';


import { exportHtmlToImage } from "../../../utils/exportHtmlToImage";

import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Box
} from '@mui/material'

import * as d3 from 'd3';

import { sankey, sankeyLinkHorizontal } from 'd3-sankey';

import LoadingButton from '@mui/lab/LoadingButton';
import ExportIcon from '@mui/icons-material/Download';

import './styles.css';

const conditions = [
  {
    classification: 'Atendida',
    description: '',
    nodeNames: ['Interagida', 'Atendimento', 'Sem pesquisa'],
  },
  {
    classification: 'Atendida',
    description: 'Cliente não respondeu a pesquisa',
    nodeNames: ['Interagida', 'Atendimento', 'Pesquisa não respondida'],
  },
  {
    classification: 'Atendida',
    description: 'Operador finalizou a chamada',
    nodeNames: ['Interagida', 'Desligada Fila'],
  },
  {
    classification: 'Atendida',
    description: 'Pesquisa respondida',
    nodeNames: ['Interagida', 'Atendimento', 'Pesquisa respondida'],
  },
  {
    classification: 'Atendida',
    description: 'Cliente respondeu a pesquisa parcialmente',
    nodeNames: ['Interagida', 'Atendimento', 'Pesquisa parcial'],
  },
  {
    classification: 'Atendida',
    description: 'Supervisor desligou a chamada',
    nodeNames: ['Interagida', 'Desligada Bot'],
  },
  {
    classification: 'Perdida',
    description: '',
    nodeNames: ['Perdida', 'Desligada pelo sistema'],
  },
  {
    classification: 'Perdida',
    description: 'Cliente não continuou o chatbot',
    nodeNames: ['Perdida', 'Timeout Bot'],
  },
  {
    classification: 'Perdida',
    description: 'Cliente não respondeu ao atendimento',
    nodeNames: ['Interagida', 'Atendimento', 'Timeout Atendimento'],
  },
  {
    classification: 'Perdida',
    description: 'Fora do horário de atendimento',
    nodeNames: ['Perdida', 'Fora do Horário'],
  },
  {
    classification: 'Perdida',
    description: 'Operador não atendeu a chamada',
    nodeNames: ['Perdida', 'Timeout Fila'],
  },
  {
    classification: 'Retida no chatbot',
    description: 'Fim de curso no chatbot',
    nodeNames: ['Retida'],
  },
  {
    classification: 'Transferência',
    description: '',
    nodeNames: ['Interagida', 'Transferida 1'],
  },
];

const sampleData = {
  "rows": [
    {
      "classification": "Atendida",
      "description": "",
      "count": 5
    },
    {
      "classification": "Atendida",
      "description": "Cliente não respondeu a pesquisa",
      "count": 1
    },
    {
      "classification": "Atendida",
      "description": "Operador finalizou a chamada",
      "count": 22
    },
    {
      "classification": "Atendida",
      "description": "Pesquisa respondida",
      "count": 1
    },
    {
      "classification": "Atendida",
      "description": "Supervisor desligou a chamada",
      "count": 23
    },
    {
      "classification": "Perdida",
      "description": "",
      "count": 1
    },
    {
      "classification": "Perdida",
      "description": "Cliente não continuou o chatbot",
      "count": 30
    },
    {
      "classification": "Perdida",
      "description": "Cliente não respondeu ao atendimento",
      "count": 5
    },
    {
      "classification": "Perdida",
      "description": "Fora do horário de atendimento",
      "count": 6
    },
    {
      "classification": "Perdida",
      "description": "Operador não atendeu a chamada",
      "count": 24
    },
    {
      "classification": "Retida no chatbot",
      "description": "Fim de curso no chatbot",
      "count": 5
    },
    {
      "classification": "Transferência",
      "description": "",
      "count": 21
    }
  ]
}

const initialData = {
  nodes: [
    { name: 'ChatBot', ref: 0 },
    { name: 'Retida', ref: 1 },
    { name: 'Perdida', ref: 2 },
    { name: 'Interagida', ref: 3 },
    { name: 'Desligada pelo sistema', ref: 4 },
    { name: 'Fora do Horário', ref: 5 },
    { name: 'Timeout Bot', ref: 6 },
    { name: 'Timeout Fila', ref: 7 },
    { name: 'Desligada Bot', ref: 8 },
    { name: 'Desligada Fila', ref: 9 },
    { name: 'Transferida 1', ref: 10 },
    { name: 'Atendimento', ref: 11 },
    { name: 'Pesquisa não respondida', ref: 12 },
    { name: 'Pesquisa respondida', ref: 13 },
    { name: 'Sem pesquisa', ref: 14 },
    { name: 'Timeout Atendimento', ref: 15 },
    { name: 'Transferida 2', ref: 16 },
    { name: 'Pesquisa parcial', ref: 17 },
  ],
  links: [
    { source: 0, target: 1, value: 0 },
    { source: 0, target: 2, value: 0 },
    { source: 0, target: 3, value: 0 },
    { source: 2, target: 4, value: 0 },
    { source: 2, target: 5, value: 0 },
    { source: 2, target: 6, value: 0 },
    { source: 2, target: 7, value: 0 },
    { source: 3, target: 8, value: 0 },
    { source: 3, target: 9, value: 0 },
    { source: 3, target: 10, value: 0 },
    { source: 3, target: 11, value: 0 },
    { source: 11, target: 12, value: 0 },
    { source: 11, target: 13, value: 0 },
    { source: 11, target: 14, value: 0 },
    { source: 11, target: 15, value: 0 },
    { source: 11, target: 16, value: 0 },
    { source: 11, target: 17, value: 0 },
  ],
}

const SankeyChart = ({ data, periodText }) => {
  const ref = useRef();
  const containerRef = useRef();

  const [sankeyType, setSankeyType] = useState("number")
  const [sankeyData, setSankeyData] = useState({
    nodes: [],
    links: [],
  })
  const [total, setTotal] = useState(0)

  const adjustColumns = (nodes) => {
    // Manually adjust the position of firstColumn
    const firstColumn = nodes.find((node) => node.index === 3);
    const firstColumnNodes = [1, 2];

    nodes.forEach((node) => {
      if (firstColumnNodes.includes(node.index)) {
        node.x0 = firstColumn.x0;
        node.x1 = firstColumn.x1;
      }
    });

    // Manually adjust the position of secondColumn
    const secondColumn = nodes.find((node) => node.index === 11);
    const secondColumnNodes = [4, 5, 6, 7, 8, 9, 10];

    nodes.forEach((node) => {
      if (secondColumnNodes.includes(node.index)) {
        node.x0 = secondColumn.x0;
        node.x1 = secondColumn.x1;
      }
    });
  }

  const adjustLinks = (nodes, links) => {
    // Iterate backwards
    for (let i = links.length - 1; i >= 0; i--) {
      const link = links[i]
      const parent = nodes[link.source.index];
      const child = nodes[link.target.index];
      const height = child.y1 - child.y0;
      if ([4, 5, 6, 7].includes(child.index)) {
        if (child.index === 7) {
          child.y1 = parent.y1;
          child.y0 = child.y1 - height;
        } else {
          child.y1 = nodes[child.index + 1].y0 - 10;
          child.y0 = child.y1 - height;
        }
      }
    }

    // Iterate onwards
    links.forEach((link) => {
      const parent = nodes[link.source.index];
      const child = nodes[link.target.index];
      const height = child.y1 - child.y0;
      if ([8, 9, 10, 11].includes(child.index)) {
        if (child.index === 8) {
          child.y0 = parent.y0;
          child.y1 = child.y0 + height;
        } else {
          child.y0 = nodes[child.index - 1].y1 + 10;
          child.y1 = child.y0 + height;
        }
      }
    })

    // Iterate backwards again for ending nodes
    for (let i = links.length - 1; i >= 0; i--) {
      const link = links[i]
      const parent = nodes[link.source.index];
      const child = nodes[link.target.index];
      const height = child.y1 - child.y0;
      if ([12, 13, 14, 15, 16].includes(child.index)) {
        if (child.index === 16) {
          child.y1 = parent.y1;
          child.y0 = child.y1 - height;
        } else {
          child.y1 = nodes[child.index + 1].y0 - 10;
          child.y0 = child.y1 - height;
        }
      }
    }
  }

  const adjustNames = (nodes) => {
    nodes.forEach((node) => {
      if (['Transferida'].some(sub => node.name.includes(sub)))
        if (node.name !== 'Desligada pelo sistema')
          // Remove equal columns identifiers
          node.name = node.name.split(' ')[0]
    })
  }

  const getLinks = (row) => {
    // Find the condition that matches the current row
    const condition = conditions.find(
      (cond) =>
        cond.classification === row.classification &&
        cond.description === row.description
    );

    // If a matching condition is found, return the indices
    if (condition) {
      return initialData.nodes
        .map((item, index) => (condition.nodeNames.includes(item.name) ? index - 1 : -1))
        .filter((index) => index !== -1);
    }

    return [];
  }

  const setupData = (data) => {
    const parsedData = JSON.parse(JSON.stringify(initialData))
    data.rows?.forEach((row) => {
      const links = getLinks(row)
      links.forEach((index) => {
        parsedData.links[index].value = parsedData.links[index].value + row.count
      })

    })

    setSankeyData(parsedData)
  }

  useEffect(() => {
    if (data)
      // setupData(sampleData);
      setupData(data);
  }, [data])

  useEffect(() => {

    if (data.rows?.length === 0 || sankeyData.nodes.length === 0 || sankeyData.links.length === 0)
      return

    const container = d3.select(ref.current);
    const width = container.node().getBoundingClientRect().width;
    const height = container.node().getBoundingClientRect().height;

    container.selectAll('*').remove();

    const svg = container.append('svg')
      .attr('width', width)
      .attr('height', height);

    const sankeyGenerator = sankey()
      .nodeWidth(20)
      .nodePadding(10)
      .extent([[1, 1], [width - 2, height - 2]]);

    const { nodes, links } = sankeyGenerator(sankeyData);

    setTotal(nodes[0].value)

    adjustColumns(nodes)
    adjustLinks(nodes, links)
    adjustNames(nodes)

    sankeyGenerator.update({ nodes, links });

    const color = d3.scaleOrdinal(d3.schemeCategory10);

    svg
      .append('g')
      .selectAll('rect')
      .data(nodes)
      .enter()
      .append('rect')
      .attr('x', (d) => d.x0)
      .attr('y', (d) => d.y0)
      .attr('width', (d) => d.x1 - d.x0)
      .attr('height', (d) => d.y1 - d.y0)
      .attr('fill', 'steelblue')
      .attr('stroke', 'black');

    svg
      .append('g')
      .selectAll('path')
      .data(links.filter(link => link.value > 0))
      .enter()
      .append('path')
      .attr('d', sankeyLinkHorizontal())
      .attr('stroke', (d) => color(d.index))
      .attr('stroke-width', (d) => Math.max(1, d.width))
      .attr('fill', 'none')
      .attr('opacity', 0.5);

    svg
      .append('g')
      .selectAll('text.node-label')
      .data(nodes.filter(node => node.value > 0))
      .enter()
      .append('text')
      .attr('class', 'node-label')
      .attr('x', (d) => (d.index === 0) ? 90 : d.x0 - 6)
      .attr('y', (d) => (d.y0 + d.y1) / 2)
      .attr('dy', '0.35em')
      .attr('text-anchor', 'end')
      .text((d) => (d.index === 0) ? `Total (${d.value})` : (sankeyType === "number") ? `${d.name} (${d.value})` : `${d.name} (${((d.value / total) * 100).toFixed(1)}%)`)
      .style('font-size', '.75rem')
      .style('fill', 'black');
  }, [sankeyData, sankeyType]);

  return (
    <>
      {data.rows?.length !== 0 &&
        <>
          <Box sx={{position:'absolute', right:'0'}}>
            <FormControl sx={{ width: '200px', position: 'absolute', right: '2rem', zIndex:1 }}>
              <InputLabel id="sankey-type-label">Tipo</InputLabel>
              <Select
                size="small"
                labelId="sankey-type-label"
                id="demo-simple-select"
                value={sankeyType}
                label="Tipo"
                onChange={(event) => setSankeyType(event.target.value)}
              >
                <MenuItem value={"number"}>Número</MenuItem>
                <MenuItem value={"percentage"}>Percentual</MenuItem>
              </Select>
            </FormControl>
            <LoadingButton startIcon={<ExportIcon />}
              sx={{ position: 'absolute', right: '2rem', top: '3rem', zIndex:1 }}
              onClick={() => exportHtmlToImage(containerRef.current)}
            >
              Exportar
            </LoadingButton>
          </Box>
          <Box className='new-graphs-wrapper'>
            <div ref={containerRef} style={{ display: "flex", flexDirection: "column", width: "100%", height: "100%", padding: "1rem", position:'relative' }}>
              <img style={{ width: '10rem', display:'none', position:'absolute', right:0 }} src="/static/media/kwik_color.f6459d28.png" alt="logo" class="logo" id="logo" className='showcopyright'></img>
              <Typography variant="subtitle1" style={{ marginBottom: "1rem" }}>Qualidade do atendimento, {periodText}</Typography>
              <div ref={ref} className="sankey-chart-container"></div>
              <Typography sx={{display:'none', position:'absolute', bottom:0}} variant="body2" align="center" className='showcopyright'>
                Copyright (c) {new Date().getFullYear()} - Instant Solutions Tecnologia e Informática Ltda.
              </Typography>
            </div>
          </Box>
        </>
      }
    </>
  );
};

export default SankeyChart;
